// Leiste über und unter dem Brett: Farbe, Name, Materialvorsprung, rechts Zusatzinfo (Zug, Status).
// Dieselbe Leiste dient im Vollbild als Beschriftung.
import { h, type VNode } from 'snabbdom';

export interface PlayerBar {
  color: 'white' | 'black';
  name: string;
  /** am Zug: grüner Punkt */
  active?: boolean;
  /** Materialvorsprung dieser Seite in Bauerneinheiten (nur > 0 wird gezeigt) */
  lead?: number;
  /** rechts: aktueller Zug, Jahr, Status */
  info?: string;
  /** Info hervorheben (Ergebnis) */
  strong?: boolean;
  /** läuft etwas (Stockfish rechnet): pulsierende Punkte */
  busy?: boolean;
}

export function playerBar(where: 'top' | 'bottom', p: PlayerBar): VNode {
  return h(`div.pbar.${where}`, { class: { active: !!p.active } }, [
    h(`span.chip.${p.color}`, { attrs: { 'aria-hidden': 'true' } }),
    h('span.name', p.name),
    p.lead && p.lead > 0 ? h('span.lead', `+${p.lead}`) : null,
    p.busy ? h('span.dots', { attrs: { 'aria-hidden': 'true' } }, [h('i'), h('i'), h('i')]) : null,
    h('span.info', { class: { strong: !!p.strong } }, p.info ?? ''),
  ]);
}
